import { useReactiveVar } from '@apollo/client';
import { HTMLAttributes, ReactElement, ReactNode } from 'react';
import { journeyHasError as journeyHasErrorVar } from '../../lib/reactives';
import { TRANSLATIONS as text } from '../../translations';
import FlashMessage from '../FlashMessage';
import styles from './Container.module.scss';

const {
  flashMessages: { journeyError },
} = text;

interface ContainerProps extends Omit<
  HTMLAttributes<HTMLDivElement>,
  'children'
> {
  children: ReactNode | ((..._args: ReactNode[]) => ReactNode);
}

export function Container({
  children,
  ...rest
}: Readonly<ContainerProps>): ReactElement {
  const journeyHasError = useReactiveVar(journeyHasErrorVar);

  return (
    <div className={styles.container} {...rest} data-qa="container">
      {journeyHasError && <FlashMessage message={journeyError} />}
      {typeof children === 'function' ? children() : children}
    </div>
  );
}

export default Container;
